<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template lang="html">
  <div class="playBtn">
    <svg width="44" height="44" xmlns="http://www.w3.org/2000/svg"
         xmlns:svg="http://www.w3.org/2000/svg">
      <g>
        <title>Play</title>
        <circle id="svg_2" r="21" cy="22" cx="22" stroke-width="2" stroke="#FFFFFF"
                stroke-opacity="0.5" fill-opacity="0.6" fill="black"/>
        <polygon points="18,15 18,29 29,22 " fill="#FFFFFF" id="Shape"/>
      </g>
    </svg>
  </div>
</template>

<script lang="js">
export default {
  name: 'play-btn',
};
</script>
